import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { DollarSign, ChevronDown } from "lucide-react";

export function EventPLTable({ events, open, onToggle }) {
  if (!events?.length) return null;
  const withRevenue = events.filter(e => e.revenue > 0);

  return (
    <Card className="border-border" data-testid="event-pl-table">
      <CardHeader className="pb-2 cursor-pointer select-none hover:bg-secondary/20 transition-colors rounded-t-lg" onClick={onToggle} data-testid="event-pl-toggle">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-sm font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-2">
              <DollarSign className="w-4 h-4" /> Per-Event P&L
            </CardTitle>
            <p className="text-xs text-muted-foreground mt-1">{withRevenue.length} events with revenue</p>
          </div>
          <ChevronDown className={`w-5 h-5 text-muted-foreground transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        </div>
      </CardHeader>
      {open && (
        <CardContent>
          <div className="overflow-x-auto">
            <Table>
              <TableHeader>
                <TableRow className="bg-secondary/30 hover:bg-secondary/30">
                  <TableHead className="text-xs font-semibold uppercase tracking-wider">Event</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider">Client</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider">Date</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Revenue</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Expenses</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Profit</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider text-right">Margin</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {withRevenue.slice(0, 30).map((ev, i) => (
                  <TableRow key={ev.event_id} data-testid={`event-pl-row-${i}`}>
                    <TableCell>
                      <div className="min-w-0"><p className="font-medium text-sm truncate max-w-[200px]">{ev.name}</p><p className="text-xs text-muted-foreground/60">{ev.revenue_source === "invoice" ? "Invoice" : "Estimate"}</p></div>
                    </TableCell>
                    <TableCell className="text-sm text-muted-foreground">{ev.client_name || "—"}</TableCell>
                    <TableCell className="text-sm text-muted-foreground whitespace-nowrap">{ev.start_date}</TableCell>
                    <TableCell className="text-right font-semibold text-sm text-primary">${ev.revenue.toLocaleString()}</TableCell>
                    <TableCell className="text-right text-sm text-red-400">${ev.expenses.toLocaleString()}</TableCell>
                    <TableCell className={`text-right font-semibold text-sm ${ev.profit >= 0 ? "text-emerald-400" : "text-red-400"}`}>${ev.profit.toLocaleString()}</TableCell>
                    <TableCell className="text-right">
                      <Badge variant="outline" className={`text-xs font-mono ${ev.margin >= 50 ? "border-emerald-500/40 text-emerald-400" : ev.margin >= 20 ? "border-amber-500/40 text-amber-400" : "border-red-500/40 text-red-400"}`}>
                        {ev.margin}%
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      )}
    </Card>
  );
}
